/* @flow */

import * as React from 'react';

type Props = {
    width?: number,
};

export function RevenueWidget(props: Props) {
    return (
        <svg
            width={props.width}
            viewBox='0 0 250 170'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path fill='#E8F4FA' d='M0 0h250v170H0z' />
            <g filter='url(#a)'>
                <rect
                    x='33'
                    y='63'
                    width='55.296'
                    height='55.296'
                    rx='13.824'
                    fill='#fff'
                    shapeRendering='crispEdges'
                />
                <path
                    d='m59.613 91.257-7.258-4.03v7.322c0 .626.341 1.205.89 1.512l6.368 3.538zm-3.742-7.482-2.726 1.516 7.509 4.169 2.682-1.49-7.374-4.148-.086-.047zm2.13-1.184 7.46 4.195 2.7-1.5-6.67-3.706a1.74 1.74 0 0 0-1.68 0l-1.814 1.015zm3.685 8.666v8.342l6.368-3.538a1.73 1.73 0 0 0 .89-1.512v-7.327l-7.258 4.03zm.808 10.264c-1.15.64-2.545.64-3.694 0l-6.566-3.646a3.8 3.8 0 0 1-1.953-3.326v-8.005a3.46 3.46 0 0 1 1.776-3.02l6.743-3.75a3.8 3.8 0 0 1 3.694 0l6.743 3.746a3.46 3.46 0 0 1 1.78 3.024v8.01a3.79 3.79 0 0 1-1.957 3.321z'
                    fill='#4D4540'
                />
            </g>
            <g filter='url(#b)'>
                <rect
                    x='95.723'
                    y='63.047'
                    width='55.296'
                    height='55.296'
                    rx='13.824'
                    fill='#fff'
                    shapeRendering='crispEdges'
                />
                <path
                    d='M122.677 81.71h-4.838a.693.693 0 0 0-.691.69v16.59c0 .38.311.69.691.69h11.059c.38 0 .691-.31.691-.69V88.62h-3.801a3.11 3.11 0 0 1-3.111-3.11zm6.053 4.838-3.979-3.979v2.942c0 .575.462 1.037 1.037 1.037zM115.074 82.4a2.77 2.77 0 0 1 2.765-2.764h5.767c.735 0 1.439.29 1.957.808l5.292 5.296c.519.518.808 1.223.808 1.957v11.292a2.77 2.77 0 0 1-2.765 2.765h-11.059a2.77 2.77 0 0 1-2.765-2.765zm3.456 1.728c0-.574.462-1.036 1.037-1.036h.691c.575 0 1.037.462 1.037 1.037 0 .574-.462 1.036-1.037 1.036h-.691a1.034 1.034 0 0 1-1.037-1.037m0 3.457c0-.575.462-1.037 1.037-1.037h.691c.575 0 1.037.462 1.037 1.037 0 .574-.462 1.036-1.037 1.036h-.691a1.034 1.034 0 0 1-1.037-1.036m7.603 7.948V92.77h-5.529v2.764zm-7.603.346v-3.456c0-.955.773-1.728 1.728-1.728h6.221c.955 0 1.728.773 1.728 1.728v3.456c0 .955-.773 1.728-1.728 1.728h-6.221a1.727 1.727 0 0 1-1.728-1.728'
                    fill='#4D4540'
                />
            </g>
            <g filter='url(#c)'>
                <rect
                    x='159.145'
                    y='63'
                    width='55.296'
                    height='55.296'
                    rx='13.824'
                    fill='#fff'
                    shapeRendering='crispEdges'
                />
                <g clipPath='url(#d)'>
                    <path
                        d='M189.69 77.999a1.04 1.04 0 0 0-.76-.59 1.03 1.03 0 0 0-.917.288L173.84 91.87a1.04 1.04 0 0 0-.288.917c.058.333.281.617.593.757l2.309 1.051.822 2.056c.113.284.345.504.635.599l1.708.571.571 1.708c.095.29.315.522.599.635l2.056.822 1.051 2.309c.14.312.424.528.757.593s.675-.046.917-.288l14.173-14.173a1.04 1.04 0 0 0 .288-.917 1.03 1.03 0 0 0-.593-.757l-2.309-1.051-.822-2.056a1.04 1.04 0 0 0-.632-.602l-1.711-.568-.568-1.71a1.06 1.06 0 0 0-.599-.636l-2.056-.822zm-13.327 14.28 12.06-12.06.601 1.33c.11.244.312.433.559.534l1.998.8.581 1.742c.103.311.345.553.656.656l1.742.58.8 1.999c.101.247.29.449.534.559l1.326.604-12.057 12.057-.605-1.325a1.03 1.03 0 0 0-.559-.535l-1.997-.8-.581-1.742a1.03 1.03 0 0 0-.656-.656l-1.742-.58-.8-1.998a1.04 1.04 0 0 0-.535-.56zm11.895-7.495a1.035 1.035 0 0 0-1.467 0 1.035 1.035 0 0 0 0 1.466l4.399 4.398c.407.407 1.06.407 1.466 0a1.033 1.033 0 0 0 0-1.466zm-5.865 5.864a1.035 1.035 0 0 0-1.467 0 1.035 1.035 0 0 0 0 1.467l4.399 4.399c.406.406 1.06.406 1.466 0a1.033 1.033 0 0 0 0-1.467zm1.466-2.932a1.035 1.035 0 0 0 0 1.466l4.399 4.4c.406.405 1.06.405 1.466 0a1.035 1.035 0 0 0 0-1.467l-4.399-4.399a1.034 1.034 0 0 0-1.466 0'
                        fill='#4D4540'
                    />
                </g>
            </g>
            <rect
                x='19.5'
                y='43.5'
                width='212'
                height='100'
                rx='10.5'
                stroke='#2E9942'
                strokeWidth='3'
                strokeDasharray='4 4'
            />
            <rect x='82' y='30' width='88' height='25' rx='4' fill='#2E9942' />
            <path
                d='M93.2 38.3c0-.332.267-.6.6-.6h3.903a.6.6 0 0 1 .424.175l5.201 5.2a.6.6 0 0 1 0 .847l-3.903 3.906a.6.6 0 0 1-.847 0l-5.2-5.2a.6.6 0 0 1-.175-.425zm.6-1.8c-.995 0-1.8.805-1.8 1.8v3.903c0 .477.19.934.528 1.272l5.2 5.2a1.8 1.8 0 0 0 2.545 0l3.902-3.902a1.8 1.8 0 0 0 0-2.546l-5.2-5.2a1.8 1.8 0 0 0-1.272-.527zm1.4 4a.8.8 0 1 0 .002-1.598.8.8 0 0 0-.002 1.598m17.387 2.834V47h-1.469v-9.074h3.913c1.625 0 2.626 1.053 2.626 2.73 0 1.287-.611 2.184-1.768 2.522L117.852 47h-1.638l-1.82-3.666zm0-1.235h2.34c.741 0 1.183-.403 1.183-1.131v-.624c0-.728-.442-1.131-1.183-1.131h-2.34zm9.407 5.057c-1.924 0-3.107-1.378-3.107-3.536s1.183-3.536 3.107-3.536c1.989 0 3.003 1.495 3.003 3.367v.533h-4.641v.221c0 1.04.637 1.781 1.781 1.781.832 0 1.391-.39 1.781-1.014l.832.819c-.507.819-1.495 1.365-2.756 1.365m0-5.967c-.975 0-1.638.728-1.638 1.768v.091h3.146v-.13c0-1.04-.572-1.729-1.508-1.729M129.585 47h-1.664l-2.301-6.76h1.404l1.027 3.081.689 2.366h.078l.689-2.366 1.053-3.081h1.352zm6.069.156c-1.924 0-3.107-1.378-3.107-3.536s1.183-3.536 3.107-3.536c1.989 0 3.003 1.495 3.003 3.367v.533h-4.641v.221c0 1.04.637 1.781 1.781 1.781.832 0 1.391-.39 1.781-1.014l.832.819c-.507.819-1.495 1.365-2.756 1.365m0-5.967c-.975 0-1.638.728-1.638 1.768v.091h3.146v-.13c0-1.04-.572-1.729-1.508-1.729M141.643 47h-1.417v-6.76h1.417v1.118h.065c.286-.728.858-1.274 1.898-1.274 1.378 0 2.197.962 2.197 2.626V47h-1.417v-4.108c0-1.053-.403-1.586-1.274-1.586-.741 0-1.469.377-1.469 1.17zm10.219 0v-1.118h-.052c-.247.663-.78 1.274-1.898 1.274-1.391 0-2.21-.949-2.21-2.613V40.24h1.417v4.121c0 1.027.429 1.573 1.3 1.573.728 0 1.443-.377 1.443-1.17V40.24h1.417V47zm6.098.156c-1.924 0-3.107-1.378-3.107-3.536s1.183-3.536 3.107-3.536c1.989 0 3.003 1.495 3.003 3.367v.533h-4.641v.221c0 1.04.637 1.781 1.781 1.781.832 0 1.391-.39 1.781-1.014l.832.819c-.507.819-1.495 1.365-2.756 1.365m0-5.967c-.975 0-1.638.728-1.638 1.768v.091h3.146v-.13c0-1.04-.572-1.729-1.508-1.729'
                fill='#fff'
            />
            <defs>
                <filter
                    id='a'
                    x='33'
                    y='63'
                    width='65.25'
                    height='65.249'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dx='9.953' dy='9.953' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix values='0 0 0 0 0.752941 0 0 0 0 0.878431 0 0 0 0 0.94902 0 0 0 1 0' />
                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3563_46941' />
                    <feBlend
                        in='SourceGraphic'
                        in2='effect1_dropShadow_3563_46941'
                        result='shape'
                    />
                </filter>
                <filter
                    id='b'
                    x='95.723'
                    y='63.047'
                    width='65.25'
                    height='65.249'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dx='9.953' dy='9.953' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix values='0 0 0 0 0.752941 0 0 0 0 0.878431 0 0 0 0 0.94902 0 0 0 1 0' />
                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3563_46941' />
                    <feBlend
                        in='SourceGraphic'
                        in2='effect1_dropShadow_3563_46941'
                        result='shape'
                    />
                </filter>
                <filter
                    id='c'
                    x='159.145'
                    y='63'
                    width='65.25'
                    height='65.249'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dx='9.953' dy='9.953' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix values='0 0 0 0 0.752941 0 0 0 0 0.878431 0 0 0 0 0.94902 0 0 0 1 0' />
                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3563_46941' />
                    <feBlend
                        in='SourceGraphic'
                        in2='effect1_dropShadow_3563_46941'
                        result='shape'
                    />
                </filter>
                <clipPath id='d'>
                    <path fill='#fff' d='M172.969 76.824h27.648v27.648h-27.648z' />
                </clipPath>
            </defs>
        </svg>
    );
}
